<template>
    <div class="boards">
  
      <b-modal
                v-model="isLoading"
                has-modal-card
                trap-focus
                :destroy-on-hide="false"
                :can-cancel="false"
                :full-screen="true"
                aria-role="dialog"
                aria-label="Dataset"
                aria-modal
                width="100%"
                scroll="keep">
  
              <div class="modal-card" style="max-height: 30px; overflow-y: auto;">
              
              <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false">
              </b-loading>
      </div>
      </b-modal>
      <b-modal
                v-model="isCardModalActive"
                has-modal-card
                trap-focus
                :destroy-on-hide="false"
                :can-cancel="false"
                :full-screen="true"
                aria-role="dialog"
                aria-label="Dataset"
                aria-modal
                width="100%"
                scroll="clip">
  
              <div class="modal-card" style="min-height: 1000px; overflow-y: auto;">
                          
                <div class="columns is-gapless">
                <div :class="'column box is-full'">
                <div class="columns is-desktop">
                <div class="column is-half is-offset-3">
  
                <section class="modal-card-body">              
                <div class="page-title-container">
                  <br><br>                
                  <b-steps
                    v-model="setupStep"
                    :has-navigation="false">
                    <b-step-item label="Profile">
                      <h2 class="subtitle is-5 has-text-centered">
                          
                          Help us customize your experience by telling us a bit about yourself
                          
                      </h2>
                        <div class="page-container">
                  
                  <form v-on:submit.prevent="onboarding($event)">
                      
                    <input type="hidden" name="Created" value="x-sheetmonkey-current-date-time" />
                      
                  <div class="columns">
                  <div class="column is-half">
                  <b-field label="Where do you work?">
                    <b-input v-model="company" name="company" expanded placeholder="Enter your company or university name" required></b-input>
                  </b-field>
                  <b-field label="Which of these best describe you?">
                  <b-select v-model="role" name="role" required expanded  placeholder="Choose a profile">
                    <option v-for="role in ['Enterprise', 'Startup', 'Student', 'Research', 'Other']" :value="role">{{ role }}</option>
                  </b-select>
                </b-field>
                  <b-field label="What industry are you in?">
                  <b-select v-model="industry" name="industry" required expanded placeholder="Choose a industry">
                    <option v-for="industry in ['E-commerce & Marketplaces', 'Shipping & Logistics', 'Banking', 'Insurance', 'Venture Capital', 'Health Care', 'Consulting & Professional Services', 'Internet & Software (e.g., SaaS)', 'Legal Services', 'Real State', 'Education / Research', 'Government', 'Other']" :value="industry">{{ industry }}</option>
                  </b-select>
                  </b-field>
                    
                  
  
                  </div>
                  <div class="column is-half is-desktop">
                  
                    <b-field label="What specific use case are you trying to solve with AI?"  expanded>
                    <b-input required v-model="how" name="how" rows="4" type="textarea" 
                    placeholder="Enter your use case, how is going today, why it's important"></b-input>
                  </b-field>
                  <b-field label="Would like to learn more?">
                    <b-checkbox name="workshop" v-model="workshop">
                        Get an invite for a weekly office hours
                    </b-checkbox>
                </b-field>
                  
                </div></div>
                
                <b-button native-type="submit" class="is-info" size="is-medium"  expanded>
                    Continue
                  </b-button>
  
  
  
              </form>
                </div>
                    </b-step-item>
  
                    <b-step-item label="Get started">
                      
                          
                          <div class="has-text-centered">
                              <h1 class="title is-4">Walk-through tutorial</h1>
                              <p>
                                  Watch this video to learn how to get started with Metatext
                              </p>
                              <br>
                              <iframe width="750" height="422" src="https://www.youtube.com/embed/S-LzuHj5jPY?si=UH7RkuocvgmOVDZY&amp;controls=0&amp;start=2&amp;modestbranding=1&amp;autohide=1&amp;showinfo=0&amp;controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                          </div>
                          <b-button @click="redirectCreate" class="is-info" size="is-medium"  expanded>
                              Go to Metatext
                          </b-button>
                    </b-step-item>
                  </b-steps>
                  
                </div>
                
                
                </section>
                
                </div>
                </div>
                
                </div>
                <div class="column">
                  <section class="hero is-info is-fullheight" >
                      <div class="hero-body">
                          
              
      <div class="">
          <p class="title is-1 pb-5">
          <span class="pb-1">
              Get ready to build and use task-specific AI models in just minutes!
          </span>
          </p>
          <!-- <p class="subtitle is-6">
          <span style="margin-bottom: 5px" data-entity="org">Classify</span> <span style="margin-bottom: 5px" data-entity="norp">Extract</span><span style="margin-bottom: 5px" data-entity="person">Generate</span>
          </p> -->
          
          <br>
          <p class="title is-4">
              🚀 Empower teams to build AI
          </p>&nbsp;&nbsp;
          <p class="subtitle">
              Metatext makes AI simple, so you can empower teams to automate workflows through the easiest no-code interface, simplest text annotation and state-of-the-art AI pipelines and MLOps tools.
          </p>
          <p class="title is-6">
              <!-- Founder, <a href="https://vemt.com" target="_blank">VEMT</a> -->
          </p>
          <br>
          <p class="title is-4">
              ⚡ Save time and money
          </p>&nbsp;&nbsp;
          <p class="subtitle">
              Say goodbye to manual data processing and hello to automation. Metatext's AI-powered tools work tirelessly in the background, so you can focus on what matters most – your business.
          </p>
          <p class="title is-6">
              <!-- Head of Product, <a href="https://pontaltech.com.br" target="_blank">Pontaltech</a> -->
          </p>
          <br>
          <p class="title is-4">
              🔒 Privacy & security
          </p>&nbsp;&nbsp;
          <p class="subtitle">
              At Metatext, we take your data privacy seriously. Rest assured, your sensitive information is protected with state-of-the-art security measures. We adhere to strict data protection policies, ensuring that your data remains confidential and is never shared with third-party advertisers.
          </p>
          <p class="title is-6">
              <!-- Head of Product, <a href="https://pontaltech.com.br" target="_blank">Pontaltech</a> -->
          </p>
      </div>
    </div>
                  </section>
                  
                </div>
              </div>
              </div>
              
            </b-modal>
  
    </div>
  </template>
  
  <script>
  import 'vue-stepper-component'
  import ModalModel from '@/components/ModelCreate.vue'
  import ModalDataset from '@/components/DatasetCreate.vue'
  import ModalGetStarted from '@/components/GetStarted.vue'
  import ModalProject from '@/components/ProjectCreate.vue'
  import Pricing from '@/components/Pricing.vue'
  
  export default {
    name: "Explore",
    props: ["username"],
    data() {
      return {
        models: [],
        isOwner: true,
        modelsShow: [
          {name: "AI Text Classifier", description: "PayPal project", type: "classification"}
        ],
        setupStep: 0,
        isLoading: true,
        isCardModalActive: false,
        isStepsClickable: true,
        isModalProjectCreateOpen: false,
        isModalModelCreateOpen: false,
        isModalDatasetCreateOpen: false,
        isModalGetStartedOpen: false,
        showTemplates: true,
        menu: 'datasets',
        items: [
          {
            name: "Get started", id: "get-started"
          },
        ],
        workshop: false,
        company: null,
        how: null,
        why: null,
        organization: null,
        role: null,
        dataPoints: null,
        industry: null,
        tools: null,
        modelType: 'classification',
        modelTypeList: [
                  {id: 'classification', name: 'Classification'}, 
                  {id: 'answering', name: 'Answering'}, 
                  // {id: 'summarization', name: 'Summarization'},
                  // {id: 'generation', name: 'Generation'}
              ]
      };
    },
    components: {
      "modal-get-started": ModalGetStarted,
      "modal-model": ModalModel,
      "modal-dataset": ModalDataset,
      "modal-project": ModalProject,
      Pricing
    },
    computed: {
      currentUser() {
            return this.$store.state.currentUser;
        },
    },
    methods: {
      onboarding(){
        // Add user profile info + sign in provider info (DisplayName and Photo URL from Google account)
        const toUpdate = {
          userId: this.$firebase.auth().currentUser.uid,
          update: {
            displayName: this.$firebase.auth().currentUser.displayName || this.$firebase.auth().currentUser.email,
            photoURL: this.$firebase.auth().currentUser.photoURL || null,
            infoProfile: {
              name: "",
              company: this.company,
              role: this.role,
              industry: this.industry,
              how: this.how,
              workshop: this.workshop
            }
          }
        }
  
        this.$store.dispatch("updateUserOnboarding", toUpdate);
  
        this.$buefy.toast.open('Thank you for joining us')
        
        //this.$router.push(`/`)
        this.setupStep = 1
  
      },
      redirectCreate(){
          this.$buefy.toast.open('Loading Metatext...')
          setTimeout(() => 
          this.$router.push(`/create`), 
          10)
  
      },
      redirectExplore(){
  
          setTimeout(() => 
          this.$router.push(`/explore`), 
          10)
  
      },
      start(){
        
        this.isLoading = true
        let hasUser = this.currentUser != undefined
      //   let hasOrganization = hasUser ? Object.hasOwn(this.currentUser, 'organizationId') : false
      //   if (hasOrganization){
      //     this.isOwner = this.currentUser.organizationId.length > 20 ?  this.currentUser.organizationId == this.currentUser.id : true
      //   }
        
        let hasInfo = hasUser ? Object.hasOwn(this.currentUser, 'infoProfile') : false
        let hasPlan = hasUser ? Object.hasOwn(this.currentUser, 'plan') && this.currentUser.plan.name != false : false
  
        if(hasUser && hasInfo && hasPlan){
          this.$router.push(`/dashboard/start`)
          this.setupStep = 1
          this.isLoading = false
          this.isCardModalActive = true
        } else if (hasInfo && !hasPlan) {
          this.$router.push(`/d/pricing`)
        } else {
          this.isLoading = false
          this.isCardModalActive = true
        }
      }
    },
    mounted(){
      this.$store.dispatch("currentUser").then( () => {
          
          setTimeout(() => 
              this.start(),
          30)
      })
    },
  };
  </script>
  
  <style lang="scss" scoped>
  .boards-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(110px, 1fr));
    gap: 9px;
    padding: 10px;
  
    .board {
      cursor: pointer;
      border: solid 1px #e6e4e4;
      border-radius: 4px;
  
      &:hover {
        background: #fafafa;
      }
  
      .info {
        padding: 16px;
  
        .name {
          display: block;
          margin-bottom: 8px;
          text-transform: capitalize;
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
  
        .description {
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 0;
          margin-bottom: 8px;
          overflow: hidden;
        }
      }
    }
  }
  
  .center {
    margin: auto;
    width: 50%;
    
    padding: 10px;
  }
  
  
  
  .setup-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(120px, 2fr));
      gap: 3em;
    
      .setup-selected {
            border: dashed 3px #bdbdbd !important;
        }
    
      .setup {
        cursor: pointer;
        border: solid 1px #e6e4e4;
        border-radius: 4px;
        
    
        &:hover {
          background: #fafafa;
          border: dashed 1px #bdbdbd;
        }
    
        &:active {
            border: dashed 2px #bdbdbd;
        }
    
        &:checked {
            border: dashed 2px #bdbdbd;
        }
        
    
        .info {
          padding: 16px;
    
          .name {
            display: block;
            margin-bottom: 8px;
            text-transform: capitalize;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
            overflow: hidden;
          }
    
          .description {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            margin: 0;
            margin-bottom: 8px;
            overflow: hidden;
          }
        }
      }
    }
    
    .setup-center {
      margin: auto;
      width: 90%;
    }
  
  </style>
  
              
  